import { Fragment } from 'react'
import classes from './Modal.module.css'
import { createPortal } from 'react-dom'

const Backdrop = props => {
    return <div className={classes.backdrop} onClick={props.closeCart} />
}

const ModalOverlay = props => {
    return <div className={classes.modal}>
        <div className={classes.content}>{props.children}</div>
    </div>
}

const portalElement = document.getElementById('overlays')

export default function Modal(props) {
    return (
        <Fragment>
            {createPortal(<Backdrop closeCart={props.closeCart}/>, portalElement)}
            {createPortal(<ModalOverlay>{props.children}</ModalOverlay>, portalElement)}
        </Fragment>
    )
}